import { useCallback, useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Card from "../../atoms/Card";
import CardHeader from "../../atoms/CardHeader";
import IconButton from "../../atoms/IconButton";
import Modal from "../../molecules/Modal";
import UsuariosCrudTable from "../../organisms/usuarios/UsuariosCrudTable";
import UsuariosCrudCreate from "../../organisms/usuarios/UsuariosCrudCreate";
import { GET_USERS } from "../../../api/apiUsers";
import useModal from "../../../hooks/useModal";
import Breadcrumb from "../../molecules/Breadcrumb";

const UsuariosCrudTemplate = () => {
    const { type } = useParams();
    const { open, isOpen, close} = useModal();
    const [usuarios, setUsuarios] = useState();
    const [loading, setLoading] = useState(false);

    const getUsuarios = useCallback (async () => {
        try {
            setLoading(true);
            const usuariosData = await GET_USERS();
            const filteredData = usuariosData.filter((user) => user.role === type);
            setUsuarios(filteredData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)
        }
    }, [type]);

    useEffect(() => {
        getUsuarios();
    }, [getUsuarios]);

    const getType = () => {
        let typeLabel;
        if (type === "GeneralAdmin") { typeLabel = "Administradores generales"; }
        else if (type === "Administrative") { typeLabel = "Administrativos"; }
        else if (type === "Resident") { typeLabel = "Residentes"; }
        else if (type === "Staff") { typeLabel = "Mantenimiento"; }

        return typeLabel;
    };

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/usuarios" },
                            { label: getType(), to: null },
                        ]}
                    />
                }
                right={<IconButton icon={FaPlus} bgColor="bg-green-600" onClick={open} />}
            />
            <Card>
                <UsuariosCrudTable data={usuarios} refetch={getUsuarios} loading={loading} />
            </Card>
            {isOpen && type &&
                <Modal title={`Agregar usuario a ${getType()}`} onClose={close}>
                    <UsuariosCrudCreate refetch={getUsuarios} onClose={close} type={type} />
                </Modal>
            }
        </div>
    );
};

export default UsuariosCrudTemplate;